import * as React from "react";
import { Modal } from "antd";
import { useContext, useState } from "react";
import { ServiceContext } from "src/services/provider/Service.provider";
import { ChangeTradePhaseTypeEnum } from "./ChangeTradePhaseTypeEnum";
import { AuthContext } from "src/components/context/AuthContext";
import IChangeTradePhaseButton from "../UploadDocument/IChangeTradePhaseButton";
import { ITrade } from "src/services/interfaces/trade/ITrade";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import ITradeApprovalPhaseLog from "../ITradeApprovalPhaseLog";
import IGenericButtons from "../IGenericButtons";
import ConfirmModalBody from "../ConfirmModalBody/ConfirmModalBody";
import { ValidateAllSpouseFieldsAreFilled, userHaveSpouse, ValidateAllUserFieldsAreFilled } from "src/util/Validations";
import hasRulesToApprove from "./ChangeTradePhaseRuleMap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faUndoAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import Tooltip from "src/components/common/Tooltip/Tooltip";

import "./ChangeTradePhaseButton.scss";
import IApproveFileS3 from '../IApproveFileS3';
import * as _ from 'lodash';

export default function ChangeTradePhaseButton(props: IChangeTradePhaseButton & IGenericButtons) {
  const { currentUser } = useContext(AuthContext);
  const { tradePhaseService } = useContext(ServiceContext);
  const [isRequesting, setIsRequesting] = useState(false);
  const [file, setFile] = useState<IApproveFileS3>(null);

  let reason = "";

  const canApprove = () => {
    let { isValid, message } = isFormFilled(props.trade);

    if (!props.trade.canSendContractToCustomer) {
      isValid = false;
      message = "Faltam documentos para poder aprovar";
    }

    return { isValid, message };
  };

  function isFormFilled(trade: ITrade) {
    let isValid: boolean = false;
    let message: string = "";
    const userIsValid = ValidateAllUserFieldsAreFilled(props.trade);
    isValid = userIsValid.isValid;
    message = userIsValid.message;

    if (userHaveSpouse(props.trade)) {
      const spouseIsValid = ValidateAllSpouseFieldsAreFilled(props.trade);
      isValid = userIsValid.isValid && spouseIsValid.isValid;
      message = userIsValid.message.concat(spouseIsValid.message);
    }
    return { isValid, message };
  }

  const userCanApproveTrade = !hasRulesToApprove(currentUser.permissions, props.trade.phase, props.trade.status);

  async function approve(reasonParam: string) {
    props.setLoading(true);
    const approveData = {
      trade: props.trade,
      reason: reasonParam,
      file,
      isPhaseApprovalOverride: props.isPhaseApprovalOverride
    } as ITradeApprovalPhaseLog;;

    await tradePhaseService
      .putInPhaseApprove(approveData)
      .then(async resp => {
        if (resp.success) {
          ShowNotification.Success("Sucesso!", "Trade Aprovado!");
          props.updateParent();
        } else {
          ShowNotification.Error("Falha na operação", "Erro: " + resp.message);
        }
      })
      .catch(error => {
        ShowNotification.Error("Falha na consulta", "Ocorreu um erro. Tente novamente.");
      })
      .finally(() => {
        props.setLoading(false);
        setIsRequesting(false);
      });
  }

  async function handleOkButton(trade: ITrade, reasonParam: string) {
    if (reasonParam.length < 2) {
      ShowNotification.Error("Comentário obrigatório!", "Ação não concluida");
      setIsRequesting(false);
      return;
    }
    props.setLoading(true);

    if (props.type === ChangeTradePhaseTypeEnum.approve) {
      approve(reasonParam);
    } else {
      ShowNotification.Info("Não é possível executar a ação", "Ação inválida");
    }
  }

  function handleFileSend(addedFile: IApproveFileS3) {
    setFile(addedFile);
  }

  function handleClick() {
    setIsRequesting(true);
    Modal.confirm({
      content: (
        <ConfirmModalBody
          onDescriptionChange={val => (reason = val)}
          onFileSend={handleFileSend}
          descriptionPlaceholder={props.confirmModalDescriptionPlaceholder}
          fileSent={file}
        />
      ),
      title: props.confirmModalTitle,
      onOk: () => {
        handleOkButton(props.trade, reason);
      },
      onCancel: () => {
        setIsRequesting(false);
      }
    });
  }

  return (
    <Tooltip text={props.validateTradeInfos ? canApprove().message : (_.isFunction(props.disabled) ? props.disabled(props.trade) : false) ? props.tooltipTitleDisabled : props.tooltipTitle}>
      <button
        disabled={
          props.validateTradeInfos
            ? !canApprove().isValid
            : (_.isFunction(props.disabled) ? props.disabled(props.trade) : false) || isRequesting || (props.type === ChangeTradePhaseTypeEnum.approve && userCanApproveTrade)
        }
        onClick={() => handleClick()}
        className={`${props.type === ChangeTradePhaseTypeEnum.reject ? "reject" : props.type === ChangeTradePhaseTypeEnum.return ? "rollback" : "approve"} change-trade-phase btn`}
      >
        <FontAwesomeIcon icon={props.type === ChangeTradePhaseTypeEnum.reject ? faTimes : props.type === ChangeTradePhaseTypeEnum.return ? faUndoAlt : faCheck} />
        {props.buttonText}
      </button>
    </Tooltip>
  );
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/RejectApproveTrade/ChangeTradePhaseButton.tsx